export enum Status {
  NOT_STARTED,
  IN_PROGRESS,
  /**
   * When completed without network or server error
   */
  SUCCESS,
  /**
   * When completed without network or server error
   */
  ERROR,
}

export const isNetworkError = (error: Error): boolean => {
  return (
    error instanceof TypeError &&
    // The spec doesn't seem to require browsers to use a sensible name to
    // discriminate NetworkError from other TypeError instances. However they
    // do set the following message consistently.
    // Firefox
    (error.message === 'NetworkError when attempting to fetch resource' ||
      // Chromium browsers (Chrome, Edge)
      error.message === 'Failed to fetch')
  );
};

export const isAborted = (error: Error): boolean => {
  // The spec require this to be a DOMException named `AbortError`.
  return error instanceof DOMException && error.name === 'AbortError';
};

export class NonClientError extends Error {}
export class ServerError extends NonClientError {
  readonly response: Response;
  constructor(message: string, response: Response) {
    super(message);
    this.response = response;
  }
}
export class NetworkError extends NonClientError {}
export class AbortError extends Error {}

/**
 * Special class indicating the promise has been cancelled.
 *
 * A canceled promise can be return with Promise.reject(new CancelError())
 * Doesn't look very good. Better probably to move to Observable instead.
 */
export class CancelError extends Error {}

export const raiseOnServerError = (response: Response): void => {
  if (response.status >= 500 && response.status < 600) {
    throw new ServerError(
      `${response.status} ${response.statusText}`,
      response,
    );
  }
};
